__webpack_require__.p = "/parth-portfolio/";